import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';

// ─── Thunks ───────────────────────────────────────────────────────────────────

export const GetRegionByEmployee = createAsyncThunk(
    'general/GetRegionByEmployee',
    async (employeeId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/GetRegionByEmployee/${employeeId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const GetSubServiceShops = createAsyncThunk(
    'general/GetSubServiceShops',
    async (parentSourceServiceShopId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/GetSubServiceShops/${parentSourceServiceShopId}`);
            // Endpoint returns a JSON string (FOR JSON PATH); parse it
            const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
            return data || [];
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// ─── Slice ────────────────────────────────────────────────────────────────────

const generalSlice = createSlice({
    name: 'general',
    initialState: {
        lastTransactionId: '',
        regionList: [],
        regionLoading: false,
        subServiceShopList: [],
        subServiceShopLoading: false,
    },
    reducers: {
        setLastTransactionId: (state, action) => {
            state.lastTransactionId = action.payload;
        },
        clearSubServiceShopList: (state) => {
            state.subServiceShopList = [];
        },
    },
    extraReducers: {
        [GetRegionByEmployee.pending]: (state) => {
            state.regionLoading = true;
        },
        [GetRegionByEmployee.fulfilled]: (state, action) => {
            state.regionList = Array.isArray(action.payload) ? action.payload : [];
            state.regionLoading = false;
        },
        [GetRegionByEmployee.rejected]: (state) => {
            state.regionLoading = false;
        },
        [GetSubServiceShops.pending]: (state) => {
            state.subServiceShopLoading = true;
        },
        [GetSubServiceShops.fulfilled]: (state, action) => {
            state.subServiceShopList = Array.isArray(action.payload) ? action.payload : [];
            state.subServiceShopLoading = false;
        },
        [GetSubServiceShops.rejected]: (state) => {
            state.subServiceShopLoading = false;
        },
    },
});

export const generalActions = generalSlice.actions;
export default generalSlice.reducer;